import { ISearchSelectOption } from '../types';

export const isElementHasOptions = (
    element: ISearchSelectOption
): boolean => {
    return !!(element && element.options && element.options.length);
}
